import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=a6ea8218&scoped=true&lang=pug&"
import script from "./FlipCard.vue?vue&type=script&lang=js&"
export * from "./FlipCard.vue?vue&type=script&lang=js&"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=a6ea8218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ea8218",
  null
  
)

export default component.exports